import {
  Typography,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import { decryptData } from "../../../crypto";
import Diler from "./Diler";
import { useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

export const QuestionRenderer = ({
  question,
  selectedLanguage,
  questionType,
  selectedOptionId,
  selectedOptionIds,
  inputAnswer,
  handleOptionChange,
  handleMultipleChoiceChange,
  handleInputChange,
  classes,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedImg, setSelectedImg] = useState("");
  const [optionClick, setOptionClick] = useState(false);

  const handleImageClick = (e) => {
    const src = e.target.src;
    if (src) {
      setSelectedImg(src);
      setOpen(true);
    }
  };

  const handleOptionImageClick = (e) => {
    const src = e.target.src;
    if (src) {
      setOptionClick(true);
      setSelectedImg(src);
      setOpen(true);
    }
  };

  const inputRef = useRef(null);

  const renderOptions = () => {
    switch (questionType) {
      case "Single":
        return (
          <ul className={classes.options}>
            {question.options.map((option, index) => (
              <li
                key={index}
                style={{ display: "list-item" }}
                onClick={(e) => {
                  // Detect if user clicked an image inside HTML
                  if (e.target.tagName === "IMG") {
                    handleOptionImageClick(e);
                  }
                }}
              >
                <div style={{ display: "inline-flex", alignItems: "center" }}>
                  <input
                    type="radio"
                    value={option.id}
                    style={{ backgroundColor: "red" }}
                    checked={Number(selectedOptionId) === option.id}
                    onChange={handleOptionChange}
                  />
                  <label
                    style={{ display: "inline-flex", alignItems: "center" }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span
                        dangerouslySetInnerHTML={{
                          __html:
                            selectedLanguage === "english"
                              ? option.option_en
                              : option.option_hi,
                        }}
                      />
                    </div>
                  </label>
                </div>
              </li>
            ))}
          </ul>
        );

      case "Multiple Choice":
        return (
          <ul className={classes.options}>
            {question.options.map((option, index) => (
              <li
                key={index}
                style={{ display: "list-item" }}
                onClick={(e) => {
                  // Detect if user clicked an image inside HTML
                  if (e.target.tagName === "IMG") {
                    handleOptionImageClick(e);
                  }
                }}
              >
                <FormControlLabel
                  style={{ display: "inline-flex", alignItems: "center" }}
                  control={
                    <Checkbox
                      checked={selectedOptionIds.includes(option.id)}
                      onChange={(e) => handleMultipleChoiceChange(e, option.id)}
                      value={option.id}
                    />
                  }
                  label={
                    <div style={{ display: "flex", alignItems: "center" }} onClick={(e) => e.preventDefault()}>
                      <span
                        dangerouslySetInnerHTML={{
                          __html:
                            selectedLanguage === "english"
                              ? option.option_en
                              : option.option_hi,
                        }}
                      />
                    </div>
                  }
                />
              </li>
            ))}
          </ul>
        );

      case "Fill In The Blanks":
        return (
          <>
            <input
              ref={inputRef}
              type="text"
              className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.numberInput}`}
              style={{
                marginBottom: "15px",
                width: "120px",
                outline: "none",
              }}
              value={inputAnswer}
              onChange={(e) => {
                const value = e.target.value;
                // Allow only digits and at most one dot
                if (/^\d*\.?\d*$/.test(value)) {
                  handleInputChange(e);
                }
              }}
              placeholder="Enter a number"
              onWheel={(e) => e.target.blur()}
              onKeyDown={(e) => {
                // Block unwanted keys directly
                if (
                  ["e", "E", "+", "-", ","].includes(e.key) ||
                  (e.key === "." && inputAnswer.includes("."))
                ) {
                  e.preventDefault();
                }
              }}
            />

            <Diler
              handleInputChange={handleInputChange}
              inputAnswer={inputAnswer}
              inputRef={inputRef}
            />
          </>
        );

      default:
        return null;
    }
  };

  return (
    <div className={classes.questionsContainerinner}>
      <Typography variant="body1" gutterBottom className={classes.questiontext}>
        <span
          onClick={(e) => {
            // Detect if user clicked an image inside HTML
            if (e.target.tagName === "IMG") {
              handleImageClick(e);
            }
          }}
          style={{
            display: "block",
            lineHeight: 1.6,
            fontSize: "18px",
          }}
          dangerouslySetInnerHTML={{
            __html:
              selectedLanguage === "english"
                ? question?.question_en
                : question?.question_hi,
          }}
        />

        <style jsx>{`
          span img {
            cursor: zoom-in;
          }
        `}</style>

        {/* Image Preview Modal */}
        <Dialog
          open={open}
          onClose={() => {
            setOpen(false);
            setTimeout(() => {
              setOptionClick(false);
            }, 300);
          }}
          maxWidth={false}
          PaperProps={{
            style: {
              width: "60vw",
              height: "65vh",
              // maxHeight: "90vh"
            },
          }}
        >
          <IconButton
            onClick={() => {
              setOpen(false);
              setTimeout(() => {
                setOptionClick(false);
              }, 300);
            }}
            sx={{
              position: "absolute",
              top: 6,
              right: 6,
              color: "white",
              backgroundColor: "rgba(0,0,0,0.5)",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" },
              padding: "4px", // smaller button size
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>

          <DialogContent
            sx={{
              p: 0,
              // background: "#000",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={selectedImg}
              alt="Question"
              style={{
                width: optionClick === true ? "40%" : "100%",
                height: "auto",
                maxHeight: "100%",
                objectFit: "contain",
              }}
            />
          </DialogContent>
        </Dialog>
      </Typography>

      {/* {(question?.description_en || question?.description_hi) && (
        <p style={{ paddingTop: "10px", paddingBottom: "10px" }}>
          Description:{" "}
          <p style={{ paddingTop: "5px", paddingBottom: "5px" }}></p>
          <span
            dangerouslySetInnerHTML={{
              __html:
                selectedLanguage === "english"
                  ? question?.description_en
                  : question?.description_hi,
            }}
          />
        </p>
      )} */}

      {questionType && (
        <>
          {decryptData(sessionStorage.getItem("exam_template")) ===
            "default" && (
            <Typography variant="h5">
              {questionType === "Fill In The Blanks" ? "Answer:" : "Options:"}
            </Typography>
          )}

          {renderOptions()}
        </>
      )}
    </div>
  );
};
